/*
 ** Import Bootstrap v5 moduls
 ** Created by @ahmad.gharaibeh@brande.ue
 */
import Modal from "bootstrap/js/dist/modal";
import Collapse from "bootstrap/js/dist/collapse";

/*
 ** Import Lazysizes plugin
 ** Created by @ahmad.gharaibeh@brande.ue
 */
import Lazysizes from "lazysizes";
//add simple support for background images:

/*
 ** Import AOS animation library
 ** Created by @ahmad.gharaibeh@brande.ue
 */
import AOS from "aos";
// ..
AOS.init({
  duration: 800,
});
/*
 ** Import Fancybox gallery library
 ** Created by @ahmad.gharaibeh@brande.ue
 */
// import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui/";

/*
 ** function for make number in Home Page couner animated
 ** Created by @ahmad.gharaibeh@brande.ue
 */
function animate(obj, initVal, lastVal, duration) {
  let startTime = null;

  //get the current timestamp and assign it to the currentTime variable
  let currentTime = Date.now();

  //pass the current timestamp to the step function
  const step = (currentTime) => {
    //if the start time is null, assign the current time to startTime
    if (!startTime) {
      startTime = currentTime;
    }

    //calculate the value to be used in calculating the number to be displayed
    const progress = Math.min((currentTime - startTime) / duration, 1);

    //calculate what to be displayed using the value gotten above
    obj.innerHTML = Math.floor(progress * (lastVal - initVal) + initVal);

    //checking to make sure the counter does not exceed the last value (lastVal)
    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      window.cancelAnimationFrame(window.requestAnimationFrame(step));
    }
  };
  //start animating
  window.requestAnimationFrame(step);
}
let counterText1 = document.getElementById("0101");
let counterText2 = document.getElementById("0102");
let counterText3 = document.getElementById("0103");
let counterText4 = document.getElementById("0104");
const load = () => {
  animate(counterText1, 0, 6000, 7000);
  animate(counterText2, 0, 850, 7000);
  animate(counterText4, 0, 236, 7000);
  animate(counterText3, 0, 20, 7000);
};

if (counterText1) {
  load();
}

export const Init = [];
